export default class hideOnScroll {
  constructor() {
    this.hideElements = document.querySelectorAll('.u-hide-on-scroll');
    this.mainVisual = document.querySelector('#main-visual');
    this.threshold = this.mainVisual ? this.mainVisual.offsetHeight : 0;
    this.toggleClass = 'js-is-hidden';
    this.lastScroll = 0;
    window.addEventListener('scroll', this.fire.bind(this));
  }

  fire() {
    var scrollPosition = window.scrollY;
    var scrollingUp = scrollPosition < this.lastScroll;
    this.lastScroll = scrollPosition;

    // しきい値を超えていない場合は処理を終了
    if (scrollPosition < this.threshold) return;

    if (scrollingUp) {
      this.hideElements.forEach(function(element) {
        element.classList.remove(this.toggleClass);
      }, this);
    } else {
      this.hideElements.forEach(function(element) {
        element.classList.add(this.toggleClass);
      }, this);
    }
  }
}
